export const PREMIUM_ALI_GEOCOMM = 'ALI_GEOCOMM';
export const PREMIUM_ALI_INDIGITAL = 'ALI_INDIGITAL';
export const PREMIUM_ESRI_MAP = 'ESRI_MAP';
export const PREMIUM_GIS_SERVICES = 'GIS_SERVICES';
export const PREMIUM_GIS_SEARCH = 'GIS_SEARCH';
export const PREMIUM_MAP_MARKUP = 'MAP_MARKUP';
export const PREMIUM_EAGLEVIEW = 'EAGLEVIEW';
export const MANAGE_COMMUNICATION = 'MANAGE_COMMUNICATION';
